module.exports = __webpack_public_path__ + "images/paper-add.1789440611829.png";